import React, { useState } from "react";
import cssClasses from "../Login/Login.module.css";
import strip2 from "../../Assets/Images/strip2.svg";
import strip3 from "../../Assets/Images/strip3.svg";
import logo from "../../Assets/Images/vjLogo.jpg";
import { makeStyles } from "@material-ui/core/styles";
import { useEffect } from "react";
import { supabase } from "../../supabaseClient";
import {
    getCPDetails,
    getFosDetails,
    resetPassword,
} from "../../Services/LoginService";
import { errorTost, successTost } from "../../Services/Toast";
import CustomInput from "../../Subcomponents/CustomInput";
import Button from "../../Subcomponents/Button";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { useNavigate } from "react-router-dom";
import { sendMailTo, sendMessage } from "../../Services/SmsService";
const useStyles = makeStyles((theme) => ({
    title: {
        color: "#1C1C1C",
        fontFamily: "Inter-Medium",
        fontSize: "2.4rem",
        lineHeight: "3.2rem",
        marginBottom: "1rem",
    },
    label: {
        display: "inline-block",
        fontFamily: "Inter-Medium",
        fontWeight: "400",
        fontSize: "1.4rem",
        lineheight: "2rem",
        /* identical to box height, or 143% */

        /* Gray/500 */

        color: "#667085",
        marginRight: "0.4rem",
    },
    signUp: {
        display: "inline-block",
        fontFamily: "Inter-Medium",
        fontWeight: "500",
        fontSize: "1.4rem",
        lineheight: "2rem",
        cursor: "pointer",
        color: "#175CD3",
    },
}));
const ResetPassword = () => {
    const navigate = useNavigate();
    const classes = useStyles();
    const [userSession, setUserSession] = useState(null);
    const [sessionObj, setSessionObj] = useState(null);
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [helperText, setHelperText] = useState({
        isPasswordValid: "",
        isConfirmPasswordValid: "",
    });
    const [validity, setvalidity] = useState({
        isPasswordValid: false,
        isConfirmPasswordValid: false,
    });
    useEffect(() => {
        supabase.auth.onAuthStateChange(async (event, session) => {
            console.log("session: ", session);
            if (event === "PASSWORD_RECOVERY") {
                setUserSession(session.access_token);
                setSessionObj(session);
                // const newPassword = prompt("What would you like your new password to be?");
                // const { data, error } = await supabase.auth.api
                //     .updateUser(session.access_token, { password: newPassword })

                // if (data) {
                //     alert("Password updated successfully!")
                // }
                // if (error) {
                //     console.log('error: ', error);
                //     alert("There was an error updating your password.")
                // }
            }
        });
    }, []);
    function resetUserPassword() {
        validations(newPassword, "password");
        validations(confirmPassword, "confirm");
        if (
            userSession &&
            newPassword !== "" &&
            validity.isPasswordValid &&
            validity.isConfirmPasswordValid
        ) {
            presentLoader();
            resetPassword(userSession, newPassword)
                .then((resp) => {
                    successTost("Password reset successfully!");
                    sendEmailAndSms();
                    navigate("/Login");
                    dismissLoader();
                })
                .catch((err) => {
                    console.log("err: ", err);
                    errorTost("Could not reset password. Try again later!");
                    dismissLoader();
                });
        } else {
            if (!userSession) {
                errorTost("User session not valid. Try resending reset link!");
            }
        }
    }
    function sendEmailAndSms() {
        // First get Type
        getCPDetails(sessionObj.user.email)
            .then((cpDetailsRes) => {
                console.log({ cpDetailsRes });
                if (cpDetailsRes.length > 0) {
                    let message = `<h4>Hello ${cpDetailsRes[0].cpId.billingName}</h4></br>
                <p>You have successfully registered with us and here are your login credentials.</p>
              <p>User ID: <b>${"CPID" + cpDetailsRes[0].cpId.cpDisplayId
                        }</b></p></br>
              <p>Password: <b>${newPassword}</b></p>
              <p>Regards,</p>
              <p>Vilas Javdekar Developers</p>`;
                    sendMail(sessionObj.user.email, "Registered Successfully", message);

                    let messageBody = {
                        number: "+" + cpDetailsRes?.[0].contactNumber,
                        message: `Hello ${cpDetailsRes[0].cpId.billingName}\nYou have successfully registered with us and here are your login credentials.\nUser ID : CPID${cpDetailsRes[0].cpId.cpDisplayId}\nPassword : ${newPassword}\npartners.vjerp.com\nRegards,\nVilas Javdekar Developers`,
                        is_international_number: cpDetailsRes?.[0].contactNumber.toString().substring(1, 3) !== "91" ? true : false,
                    };
                    sendMessage(messageBody)
                        .then((resp) => {
                            if (resp.data.success) {
                                successTost('Reset password sent to registered mobile number!');
                                return true;
                            } else {
                                if (resp?.data?.error) {
                                    errorTost('Could not send reset password to registered mobile number!');
                                    return false;
                                }
                            }
                        })
                        .catch((err) => {
                            console.log(err.message);
                            return false;
                        });
                } else {
                    getFosDetails(sessionObj.user.email)
                        .then((fosDetailsRes) => {
                            console.log({ fosDetailsRes });
                            if (fosDetailsRes.length > 0) {
                                let message = `<h4>Hello ${fosDetailsRes[0].name}</h4></br>
                <p>You have successfully registered with us and here are your login credentials.</p>
                  <p>User ID: <b>${"FOSID" + fosDetailsRes[0].fosDisplayId
                                    }</b></p></br>
                <p>Password: <b>${newPassword}</b></p>
                <p>Regards,</p>
                <p>Vilas Javdekar Developers</p>`;
                                sendMail(
                                    sessionObj.user.email,
                                    "Registered Successfully",
                                    message
                                );
                                // **message
                                let messageBody = {
                                    number: "+" + fosDetailsRes?.[0].contactNumber,
                                    message: `Hello ${fosDetailsRes[0].name}\nYou have successfully registered with us and here are your login credentials.\nUser ID : FOSID${fosDetailsRes[0].fosDisplayId}\nPassword : ${newPassword}\npartners.vjerp.com\nRegards,\nVilas Javdekar Developers`,
                                    is_international_number: fosDetailsRes?.[0].contactNumber.toString().substring(1, 3) !== "91" ? true : false,
                                };
                                sendMessage(messageBody)
                                    .then((resp) => {
                                        if (resp.data.success) {
                                            successTost('Reset password sent to registered mobile number!');
                                            return true;
                                        } else {
                                            if (resp?.data?.error) {
                                                errorTost('Could not send reset password to registered mobile number!');
                                                return false;
                                            }
                                        }
                                    })
                                    .catch((err) => {
                                        console.log(err.message);
                                        return false;
                                    });
                            }
                        })
                        .catch((err) => {
                            errorTost(err.message);
                        });
                }
            })
            .catch((err) => {
                errorTost(err.message);
            });
    }
    function sendMail(email, subject, message) {
        let body = {
            to: [email],
            subject: subject,
            message: message,
        };
        sendMailTo(body)
            .then((resp) => {
                console.log(resp);
            })
            .catch((err) => {
                console.log(err);
            });
    }
    function validations(value, type) {
        let errors = helperText;
        if (type === "password") {
            validity.isPasswordValid = false;
            if (!value.trim()) {
                errors.isPasswordValid = "Please Enter Password!";
            } else {
                if (value.length < 6) {
                    errors.isPasswordValid =
                        "Password should contain atleast 6 Characters!";
                } else if (value.search(/[A-Z]/) < 0) {
                    errors.isPasswordValid =
                        "Password should contain atleast 1 Uppercase!";
                }
                //  else if (value.search(/[a-z]/) < 0) {
                //   errors.isPasswordValid =
                //     "Password should contain atleast 1 LowerCase.";
                // }
                else if (value.search(/[0-9]/) < 0) {
                    errors.isPasswordValid = "Password should contain atleast 1 number!";
                } else {
                    errors.isPasswordValid = "";
                    validity.isPasswordValid = true;
                }
            }
        } else {
            validity.isConfirmPasswordValid = false;
            if (!value.trim()) {
                errors.isConfirmPasswordValid = "Please Enter Confirm Password!";
            } else {
                if (value !== newPassword) {
                    errors.isConfirmPasswordValid = "Passwords do not match!";
                } else {
                    errors.isConfirmPasswordValid = "";
                    validity.isConfirmPasswordValid = true;
                }
            }
        }
        setHelperText(errors);
    }
    return (
        <div className={cssClasses.wrapperPage}>
            <div className={cssClasses.backgroundImage}>
                <img
                    src={strip2}
                    className={cssClasses.strip2}
                    alt="backgroundImage"
                ></img>
                <img
                    src={strip3}
                    className={cssClasses.strip3}
                    alt="backgroundImage"
                ></img>
                <div className={cssClasses.registerationBlock}>
                    <div>
                        <img src={logo} style={{ width: "23rem" }} alt="vj-logo"></img>
                    </div>
                    <div className={classes.title}>Welcome Back</div>
                    <div style={{ textAlign: "left" }}>
                        <CustomInput
                            value={newPassword}
                            label={"New Password"}
                            mandatory={true}
                            handleChange={(value) => {
                                // let errors = helperText;
                                // if (!value.trim()) {
                                //     errors.isPasswordValid = "Please Enter Password";
                                // } else if (value.length < 6) {
                                //     errors.isPasswordValid = "Password should contain atleast 6 Characters.";
                                // } else if (value.search(/[A-Z]/) < 0) {
                                //     errors.isPasswordValid = "Password should contain atleast 1 Uppercase.";
                                // }
                                // //  else if (value.search(/[a-z]/) < 0) {
                                // //   errors.isPasswordValid =
                                // //     "Password should contain atleast 1 LowerCase.";
                                // // }
                                // else if (value.search(/[0-9]/) < 0) {
                                //     errors.isPasswordValid = "Password should contain atleast 1 number.";
                                // } else {
                                //     errors.isPasswordValid = "";
                                // }
                                // setHelperText(errors);
                                setNewPassword(value);
                                validations(value, "password");
                                validations(confirmPassword, "confirm");
                            }}
                            placeholder="Enter your new password"
                            inputType="password"
                            helperText={helperText.isPasswordValid}
                            onKeyPress={(event) => {
                                console.log(event);
                                if (event.key === "Enter") {
                                    resetUserPassword();
                                }
                            }}
                        />
                    </div>
                    <div style={{ textAlign: "left" }}>
                        <CustomInput
                            value={confirmPassword}
                            label={"Confirm Password"}
                            mandatory={true}
                            handleChange={(value) => {
                                // let errors = helperText;
                                // if (!value.trim()) {
                                //     errors.isConfirmPasswordValid = "Please Enter Password!";
                                // } else if (value.length < 6) {
                                //     errors.isConfirmPasswordValid = "Password should contain atleast 6 Characters!";
                                // } else if (value.search(/[A-Z]/) < 0) {
                                //     errors.isConfirmPasswordValid = "Password should contain atleast 1 Uppercase!";
                                // }
                                // //  else if (value.search(/[a-z]/) < 0) {
                                // //   errors.isConfirmPasswordValid =
                                // //     "Password should contain atleast 1 LowerCase.";
                                // // }
                                // else if (value.search(/[0-9]/) < 0) {
                                //     errors.isConfirmPasswordValid = "Password should contain atleast 1 number!";
                                // } else if (value !== newPassword) {
                                //     errors.isConfirmPasswordValid = "Password does not match!";
                                // } else {
                                //     errors.isConfirmPasswordValid = "";
                                // }
                                // setHelperText(errors);
                                setConfirmPassword(value);
                                validations(value, "confirm");
                            }}
                            placeholder="Enter confirm password"
                            inputType="password"
                            helperText={helperText.isConfirmPasswordValid}
                        // onKeyPress={(event) => {
                        //     console.log(event);
                        //     if (event.key === "Enter") {
                        //         resetUserPassword();
                        //     }
                        // }}
                        />
                    </div>
                    <div>
                        <Button
                            style={{
                                color: "#ffffff",
                                backgroundColor: "#155EEF",
                            }}
                            btnName={"Reset Password"}
                            clicked={resetUserPassword}
                            // isLoading={isLoginLoading}
                            loaderColor={"#fff"}
                            disable={
                                !validity.isPasswordValid || !validity.isConfirmPasswordValid
                            }
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
